import { render, staticRenderFns } from "./DesignSearchNw.vue?vue&type=template&id=49b7a8c3&scoped=true"
import script from "./DesignSearchNw.vue?vue&type=script&lang=js"
export * from "./DesignSearchNw.vue?vue&type=script&lang=js"
import style0 from "./DesignSearchNw.vue?vue&type=style&index=0&id=49b7a8c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b7a8c3",
  null
  
)

export default component.exports